import { List, Paper, makeStyles } from "@material-ui/core";
import { ListItem } from "@ofqual/portal-components/components/List/ListItem";
import {
  formatUtcDate,
  standardDateFormats,
} from "@ofqual/portal-core/core/utils/dateUtils";
import { AccountCircle } from "@material-ui/icons";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ItemsState } from "../../redux/state";
import { sarsStatusService } from "../../services";
import { useLookup } from "@ofqual/portal-core/core/hooks";

const SEARCH_STATE_KEY = "search";

const useStyles = makeStyles((theme) => ({
  active: {
    ...theme.list.itemPrimary,
  },
}));

export const ItemsList: React.FC<{ state: ItemsState }> = ({ state }) => {
  const classes = useStyles();

  const { response } = state;
  const history = useHistory();
  const { pathname, search } = useLocation();
  const navigate = (id: string) =>
    history.push(`${pathname}/${id}`, { [SEARCH_STATE_KEY]: search });

  const [statusLookups] = useLookup(sarsStatusService);

  function AddDaysToDate(date: string, offset:number) {
    var dateString = date; 
   
    var newData = dateString.replace(/(\d+[/])(\d+[/])/, "$2$1");
    var data = new Date(newData);
    data.setDate(data.getDate() + offset);
    var yearOnly = data.toLocaleString("en-GB", { hour12: false }).split(",");
    return yearOnly[0];
  }

  function stringify(value:unknown) {
    switch (typeof value) {
      case 'string': case 'object': return JSON.stringify(value);
      default: return String(value);
    }
  };

  function compareDatesUk(date1: string)
  {
    var date2 = new Date();
    var newData = date1.replace(/(\d+[/])(\d+[/])/, "$2$1");
    var data = new Date(newData);
    return data < date2
  }


//   function dummy()
//   {
//     var id = "997317A2-05B1-EC11-997E-281878731F90";
//     var type = 2;
//     var date = new Date();
//     date.setDate(date.getDate() + 5);
//     var yearOnly = date.toLocaleString("en-GB", { hour12: false }).split(",");

//     const insertStatement = `      
//       INSERT INTO [sars].[SarsEventLog]
//            ([SarsId]
//            ,[EventType]
//            ,[EventDate]
//            ,[EventDesc]
//            ,[CreatedByUpn]
//            ,[CreatedByDisplayName])
//      VALUES
//            (
//             CONVERT(uniqueidentifier,'${id}')
//            ,${type}
//            ,'${yearOnly[0]}'
//            ,'{Oldvalue:1, newvalue:2}'
//            ,'bilbo@wow.com'
//            ,'bilbo bagins')
// `;    
//     console.log("dummy insert ", insertStatement);
//   }
//   dummy();

  return (
    <Paper>
      <List disablePadding>
        {response.data.map((item, index) => (
          <React.Fragment key={item.id}>
            <ListItem
              Icon={AccountCircle}
              button
              alignItems="flex-start"
              onClick={() => navigate(item.id)}
              divider
              className={classes.active}
              data-test="row"
              primaryText={`${item.caseTitle}`}
              secondaryDetails={[
                {
                  heading: "Case lead",
                  value: item.caseLeadDisplayName ?? "Unassigned",
                },
                {
                  heading: "Reference",
                  value: item.referenceNumber,
                },
                {
                  heading: "Received on",
                  value: !!item.dateReceived
                    ? formatUtcDate(item.dateReceived, standardDateFormats.DATE)
                    : "Unknown",
                },
                {
                  heading: "Due on",
                  value: !!item.dateResponseDue
                    ? AddDaysToDate(
                        stringify(
                          formatUtcDate(
                            item.dateResponseDue,
                            standardDateFormats.DATE
                          )
                        ),
                        item.pausedTime
                      )
                    : "Unknown",
                },
              ]}
              chipTexts={[
                {
                  text: `${
                    item.status === 1
                      ? `Status: Open due: ${AddDaysToDate(
                          stringify(
                            formatUtcDate(
                              item.dateResponseDue,
                              standardDateFormats.DATE
                            )
                          ),
                          item.pausedTime
                        )}`
                      : `Status: ${
                          statusLookups.find((x) => x.id === item.status)
                            ?.label ?? "Unknown"
                        }`
                  }`,
                  colour:
                    item.status === 1 &&
                    compareDatesUk(
                      AddDaysToDate(
                        stringify(
                          formatUtcDate(
                            item.dateResponseDue,
                            standardDateFormats.DATE
                          )
                        ),
                        item.pausedTime
                    ))
                      ? "#cd5c5c"
                      : null,
                },
              ]}
            />
          </React.Fragment>
        ))}
      </List>
    </Paper>
  );
};
